export default "__VITE_ASSET__DLwPDvBI__"